import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {LocationHolderType} from "../../../commons/types/locationHolder.type";
import {LocationService} from "../../../commons/services/location-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {$agentsFactory} from "../../../agents/$agents.factory";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {$bringozLocationsFactory} from "../../../commons/$bringozLocations.factory";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {LocationsFacadeService} from "../../../commons/angular/services/locations/locations-facade.service";
import {LocationModel} from "../../../commons/models/location.model";
import {Subscription} from "rxjs";
import {AccountsService} from "../../../account/services/accounts-service.service";

export class DeliveriesGroupSelectorCtrl implements IController {
  deliveriesViewCtrl: any;
  isAgentSectionEnabled: any;
  deliveriesSettings: any;
  branchIds: any[];
  viewTableSettings: ViewSettingsModel;
  isAgentsPanelOpen?: boolean;
  isRoutesPanelOpen?: boolean;
  accountIds: string[];
  depotIds: string[];
  agentIds: string[];

  private agentsRef: any;
  private depotsRef: any;
  private accountsRef: any;
  private agentLocationsRef: any;
  private agentRef: any;

  private depots: any;
  private agents: any;
  private accounts: AccountModel[];
  private selectedAgent: any;
  private selectedAgentsGroup: any;
  private highlightedItineraryTaskId: any;
  private isTableEnabled: any;
  private isSmallScreen: any;
  private expandedRoute: any;
  private highlightedItineraryServiceId: any;
  private selectedAgentsType: any;
  private isItineraryMode: any;
  private pushesTimeoutRef: any;
  private maxUserIdleTimeMinutes: number;
  public selectLocationsSubscription: Subscription;

  /* @ngInject */
  constructor(private $agents: $agentsFactory, private $log, private $scope, private $accounts: $accountsFactory, private $timeout: ITimeoutService,
              private IAMPermissions, private resizeService: ResizeService, private $depots, private $mdMedia, private routesService: RoutesService,
              private commonsDialogService: CommonsDialogService, private locationService: LocationService,
              private splitService: SplitService, private commonsService: CommonsService, private locationsFacadeService: LocationsFacadeService, private accountsService: AccountsService) {
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
  }

  $onInit() {
    this.agentsRef = this.$agents();
    this.depotsRef = this.$depots();
    this.accountsRef = this.$accounts();

    this.depots = [];
    this.agents = [];
    this.accounts = [];

    if (!!this.viewTableSettings) {
      this.deliveriesViewCtrl.viewTableSettings = this.viewTableSettings;

      if (this.deliveriesViewCtrl.filterConfig.deliveriesSettings.mapColumns &&
        _.isEqual(_.size(this.deliveriesViewCtrl.filterConfig.deliveriesSettings.mapColumns), _.size(this.viewTableSettings.settings))) {
        this.deliveriesViewCtrl.filterConfig.deliveriesSettings.mapColumns = this.viewTableSettings.settings;
      }
    }

    this.deliveriesViewCtrl.panelSettings.agents = false;
    this.deliveriesViewCtrl.panelSettings.routes = false;
    this.selectedAgent = null;
    this.selectedAgentsGroup = 'Active';
    this.isTableEnabled = true;

    // For parent to know if should get deliveries for the map (different query then table);
    if (!_.get(this.deliveriesViewCtrl.mapDeliveries, 'length')) {
      this.deliveriesViewCtrl.getDeliveriesByMapQuery();
    }

    this._getAgentsByQuery();
    this._initPushesTimer();
    this._setDepots();
    this._setAccounts();

    // Agents Location Change Event Listener

    this.locationsFacadeService.subscribeToChannels();

    this.selectLocationsSubscription = this.locationsFacadeService.selectLocations()
      .subscribe((updatedLocations) => {
        _.forEach(updatedLocations, (updatedLocation) => {
          this._updateAgentLocation(updatedLocation);
        })

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {});
      })

    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })

    // $onDestroy Helper
    this.$scope.$on('$destroy', (scope) => {
      if (_.get(scope, 'currentScope.$ctrl.pushesTimeoutRef')) {
        scope.currentScope.$ctrl.$timeout.cancel(scope.currentScope.$ctrl.pushesTimeoutRef);
        scope.currentScope.$ctrl.pushesTimeoutRef = undefined;
      }
    })

  }

  $onChanges(changes) {
    if (changes.isAgentSectionEnabled && !changes.isAgentSectionEnabled.isFirstChange()) {
      if (!this.isAgentSectionEnabled) {
        this.selectedAgent = undefined;
      }
    }

    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      if (!changes.depotIds) {
        this._setDepots();
      }
      if (!changes.accountIds) {
        this._setAccounts();
      }
      if (!changes.agentIds) {
        this._getAgentsByQuery();
      }
    }

    if (changes.accountIds && !changes.accountIds.isFirstChange()) {
      this._setAccounts();
    }

    if (changes.depotIds && !changes.depotIds.isFirstChange()) {
      this._setDepots();
    }

    if (changes.agentIds && !changes.agentIds.isFirstChange()) {
      this._getAgentsByQuery();
    }

    if (changes.isAgentsPanelOpen && !changes.isAgentsPanelOpen.isFirstChange()) {
      if (!this.isAgentsPanelOpen) {
        this.selectedAgent = undefined;
      }
    }

    if (changes.isRoutesPanelOpen && !changes.isRoutesPanelOpen.isFirstChange()) {
      if (!this.isRoutesPanelOpen) {
        this.expandedRoute = undefined;
      }
    }

  }

  $doCheck() {
    this.isSmallScreen = !this.$mdMedia('gt-sm');

    if (!_.get(this.deliveriesViewCtrl, 'panelSettings.agents') && this.selectedAgent) {
      this.closeAgentsPanel();
    }
    if (!_.get(this.deliveriesViewCtrl, 'panelSettings.routes') && this.expandedRoute) {
      this.closeRoutesPanel();
    }
  }

  $onDestroy() {
    this._destroyPushesTimer();
    this.locationsFacadeService.removeAllLocations();
    this.selectLocationsSubscription.unsubscribe();
  };

  toggleTable() {
    this.isTableEnabled = !this.isTableEnabled;
    this.resizeService.resize();
  }

  closeAgentsPanel() {
    this.deliveriesViewCtrl.panelSettings.agents = false;
    this.selectedAgent = null;

    this.resetHighlightedTasks();
    this.resizeService.resize(300);
  }

  onHighlightedTaskChanged(serviceId, taskId) {
    this.highlightedItineraryServiceId = serviceId;
    this.highlightedItineraryTaskId = taskId;
  }

  onAgentsGroupChange(group) {
    this.selectedAgentsGroup = group;
    this.selectedAgent = null;

    this._getAgentsByQuery();
  }

  onAgentClick(agent) {

    // Open Section If Closed
    if (!this.deliveriesViewCtrl.panelSettings.agents) {
      this.deliveriesViewCtrl.panelSettings.agents = true;
    }
    if (!_.isEqual(agent.id, _.get(this.selectedAgent, 'id'))) {
      this.selectedAgent = agent;
      this.isItineraryMode = true;
      this.resetHighlightedTasks();
    }
    this.resizeService.resize(300);
  }

  onRouteSelect(route) {
    if (!route) {
      this.expandedRoute = undefined;
    } else {
      this.routesService.getRoutes(route.id, undefined, true)
        .then((expandedRoutes) => {
          this.expandedRoute = expandedRoutes[0];
        })
    }
  }

  closeRoutesPanel() {
    this.deliveriesViewCtrl.panelSettings.routes = false;
    this.expandedRoute = undefined;
    this.resizeService.resize(300);
  }

  // ******************************
  //        Private methods
  // ******************************


  private _getAgentsByQuery() {
    this.locationsFacadeService.removeLocationsByIds(this.agents?.map(a => a.id));
    this.agents = [];

    this.getAgentIdsByQuery()
      .then((agentIds) => {
        return this.agentsRef.$asyncValues(agentIds);
      })
      .then((agents) => {
        this.agents = agents;
        this._getAgentsLocations(_.map(agents, 'id'));
      })
      .catch((error) => {
        this.$log.error('Failed to get agents @deliveriesMapView@getAgentIdsByQuery', error)
      })
  }

  private _getAgentsLocations(agentIds) {
    const payload = _.map(agentIds, (id) => {
      return {
        holderId: id,
        holder: LocationHolderType.Agent
      }
    })

    this.locationsFacadeService.getLocations(payload);
  }

  private _updateAgentLocation(updatedLocation) {
    const agentIndex = _.findIndex(this.agents,(a: any) => {
      return a.id === updatedLocation.holderId
    });
    if (agentIndex > -1 && this.agents[agentIndex].lastKnownLocation.updatedAt < updatedLocation.updatedAt) {
      const agentsCopy = angular.copy(this.agents);

      if (!agentsCopy[agentIndex].lastKnownLocation) {
        agentsCopy[agentIndex].lastKnownLocation = {};
      }

      agentsCopy[agentIndex].lastKnownLocation.coordinates = updatedLocation.coordinates;
      this.agents = agentsCopy;
    }
  }

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();
            // this._getAgentsLocations(_.map(this.agents, 'id'));
          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }

  private resetHighlightedTasks() {
    this.highlightedItineraryServiceId = null;
    this.highlightedItineraryTaskId = null;
  }

  private getAgentIdsByQuery() {

    const queryPayload = {
      status: undefined,
      group: undefined,
      agentTypes: this.selectedAgentsType ? [this.selectedAgentsType] : undefined,
      sortByLoad: true,
      branchIds: this.branchIds,
      ids: this.agentIds,
      active: true
    };

    if (!!this.selectedAgentsGroup) {
      if (_.isEqual(this.selectedAgentsGroup, 'OffDuty')) {
        queryPayload.status = this.selectedAgentsGroup;
      } else {
        queryPayload.group = this.selectedAgentsGroup === 'Active' ? 'Active' : undefined;
      }
    }

    return this.agentsRef.$getAll(queryPayload);
  }

  private _setDepots() {
    if (this.IAMPermissions.hasPermission('depots.list')) {
      this._getDepots().then((depots) => {
        this.depots = depots;
      })
    }
  }

  private _setAccounts() {
    if (this.IAMPermissions.hasPermission('accounts.supply.list')) {
      this._getAccounts().then((accounts) => {
        this.accounts = accounts;
      })
    }
  }

  private _getDepots() {
    const query = {
      branchIds: this.branchIds,
      ids: this.depotIds
    }
    return this.depotsRef.$getAll(query)
      .then((depotIds) => {
        return this.depotsRef.$asyncValues(depotIds);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('failed to depots @deliveriesMapView@$onInit', error)
        }
      });
  }


  private _getAccounts() {
    const query = {
      isDemand: true,
      limit: 200,
      isActive: true,
      branchIds: this.branchIds,
      ids: this.accountIds
    }
    // return this.accountsRef.$getAll(query)
    //   .then((ids) => {
    //     return this.accountsRef.$asyncValues(ids);
    //   })
    //   .catch((error) => {
    //     if (error) {
    //       this.$log.error('failed to accounts @deliveriesMapView@$onInit', error)
    //     }
    //   });

    return this.accountsService.getAll(query)
      .then((accounts: AccountModel[]) => {
        return accounts;
      })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesMapView', {
    require: {
      deliveriesViewCtrl: '^deliveriesView'
    },
    bindings: {
      isAgentSectionEnabled: '<',
      deliveriesSettings: '<',
      branchIds: '<',
      viewTableSettings: '<',
      isAgentsPanelOpen: '<?',
      isRoutesPanelOpen: '<?',
      accountIds: '<',
      depotIds: '<',
      agentIds: '<'
    },
    template: require('./deliveries-map-view.html').default,
    controller: DeliveriesGroupSelectorCtrl
  });
